import { CountryConfigNames } from '../../../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../../../hooks/use-country-config';

export const useRateShopper = () => {
  const [rateShopperEnabled, shippingStrategyData] = useCountryConfig(CountryConfigNames.ShippingStrategy);
  const {
    requirePackage,
    requireConfirmation,
    prePopulatePackage,
    prePopulateConfirmation,
    ignoreConfirmationBulkUpdate,
    ignorePackageBulkUpdate,
  } = shippingStrategyData || {};

  return {
    rateShopperEnabled,
    requirePackage: requirePackage?.toLowerCase() === 'true',
    requireConfirmation,
    prePopulatePackage,
    prePopulateConfirmation,
    ignoreConfirmationBulkUpdate,
    ignorePackageBulkUpdate,
  };
};
